// to checking if form have changes
export function isFormChange(form: any, tempForm: any) {
    return JSON.stringify(form) === JSON.stringify(tempForm);
}

// to set default value if valve type is changed
export function onTypeChange(form: any) {
    if (!form.actuatorType) {
        return
    }

    switch (form.actuatorType) {
        case 'Pneumatic':
            form.fullyOpen = null
            form.fullyClose = null
            form.jammed = null
            form.hydraulicReturn = null
            break;

        case 'Manual':
            form.actuatorModel = ''
            form.openingSec = null
            form.openingCm = null
            form.closingSec = null
            form.closingCm = null
            form.hydraulicReturn = null
            break;

        case 'Hydraulic':
            form.fullyOpen = null
            form.fullyClose = null
            form.jammed = null
            form.actuatorModel = ''
            form.openingSec = null
            form.openingCm = null
            form.closingSec = null
            form.closingCm = null
            break;
    }
}